import React from 'react'

const Clipboard = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/clipboard',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M17 18.438V3.813a.55.55 0 0 0-.538-.563h-1.616a.55.55 0 0 0-.538.563c0 .31.24.562.538.562h1.077v13.5H4.077v-13.5h1.077a.551.551 0 0 0 .538-.563.551.551 0 0 0-.538-.562H3.538A.551.551 0 0 0 3 3.813v14.624a.55.55 0 0 0 .538.563h12.924a.55.55 0 0 0 .538-.563zM7.308 3.813h1.077a.551.551 0 0 0 .538-.563c0-.62.483-1.125 1.077-1.125s1.077.505 1.077 1.125c0 .31.24.563.538.563h1.077v1.124H7.308V3.813zM13.769 5.5V3.25a.55.55 0 0 0-.538-.563h-1.146C11.846 1.719 11.002 1 10 1s-1.846.718-2.086 1.688H6.769a.551.551 0 0 0-.538.562V5.5c0 .31.241.563.538.563h6.462a.55.55 0 0 0 .538-.563z'
        fill={primaryColor}
      />
      <path
        d='M8.395 13.505l-2.182-2.143a.705.705 0 0 1 0-1.01.736.736 0 0 1 1.029 0l1.667 1.638 3.85-3.78a.736.736 0 0 1 1.028 0c.284.279.284.73 0 1.01l-4.364 4.285a.732.732 0 0 1-1.028 0z'
        fill={secondaryColor}
      />
    </g>
  </svg>
)

export default Clipboard
